<main id="db-wrapper" class="bg-light">
    <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
    <section id="page-content">
        <div class="header">
          <app-only-admin-navigation></app-only-admin-navigation>
        </div>
        <div class="container-fluid p-4">
          <div class="row gx-3" *ngIf="loading">
            <div class="col-lg-12">
              <app-form-spinner></app-form-spinner>
            </div>
          </div>
        <div class="row" *ngIf="!loading">
            <p-table
              #dt1
              [value]="Users" dataKey="id" [rows]="10" [loading]="loading" [paginator]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="['name', 'email', 'roles']">
              <!-- Table Headers and Filters -->

              <ng-template pTemplate="caption">
                <div class="d-flex justify-content-between">
                    <button pButton  class="btn btn-primary"  (click)="clear(dt1)">
                      Clear
                    </button>
                    <div class="col-lg-4">
                      <input pInputText class="form-control" type="text" (input)="onSearchInput($event, dt1)" placeholder="Search keyword" />
                    </div>
                </div>
            </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th>User</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-tenant>
                <tr>
                  <td>
                    <a class="d-flex align-items-center" >
                      <div class="avatar avatar-circle">
                        <img class="avatar-img" src="{{tenant.image}}" alt="Image Description">
                      </div>
                      <div class="ms-3">
                        <span class="d-block h5 text-inherit mb-0">{{ tenant.name }}
                         <i class="bi-patch-check-fill text-primary" data-toggle="tooltip" data-bs-placement="top" title="Top endorsed"></i></span>
                        <span class="d-block fs-5 text-body">{{ tenant.email }}</span>
                      </div>
                    </a>
                   </td>
                  <td>
                    <span class="d-block h5 mb-0">{{ tenant.roles }}</span>
                  </td>
                  <td>
                    <span class="col-lg-12">
                      <a   class="btn btn-primary" [routerLink]="['/', tenant.name]">View User</a>
                    </span>
                    <span class="col-lg-12">
                      <button class="btn btn-danger ms-2" data-bs-toggle="modal" href="#exampleModalToggle" role="button" (click)="selectRecord(tenant.id)" >Delete User</button>
                    </span>
                    <span class="col-lg-12">
                      <button class="btn btn-info ms-2" data-bs-toggle="modal" href="#AccessModel" role="button"  (click)="selectRecord(tenant.id)" >Manage Access</button>
                    </span>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4">No data found.</td>
                </tr>
              </ng-template>
            </p-table>
        </div>

      </div>

    </section>
  </main>


  <div class="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalToggleLabel">Confirm Delete</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
          <h4> Are you sure you want to delete this record? It will be permanently removed. </h4>
          <img src="../../../../assets/images/Mobile/q.avif" alt="" class="img-fluid text-center" style="height: 200px;">
        </div>
        <div class="modal-footer" *ngIf="!loading">
          <button class="btn btn-danger" (click)="deleteRecords()">Delete</button>
          <button class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
        <div class="modal-footer" *ngIf="loading">
          <button class="btn btn-danger" ><div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
            </div></button>
          <button class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="AccessModel" aria-hidden="true" aria-labelledby="AccessModelLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="AccessModelLabel">Take Action Against Profile</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="pt-5">
        <div class="modal-body text-center">

            <div class="row g-3" >
              <div class="mb-1">
                <label for="status" class="form-label">Please Select Access Level</label>
                <select  id="status" class="form-select form-control-lg" formControlName="status" >
                 <option value="">Choose One</option>
                 <option value="Active">Active</option>
                 <option value="Block">Block</option>
                </select>
                <div class="error-message text-danger" *ngIf="userForm.get('status')?.invalid && userForm.get('email')?.touched">
                  <ng-container *ngIf="userForm.get('status')?.hasError('required')">Email is Required</ng-container>
                  <ng-container *ngIf="userForm.get('status')?.hasError('status')">Email format is incorret</ng-container>
                </div>
              </div>
            </div>


        </div>
        <div class="modal-footer" *ngIf="!loading">
          <button type="submit" class="btn btn-primary" [disabled]="userForm.invalid" >Save</button>
          <a class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</a>
        </div>
        <div class="modal-footer" *ngIf="loading">
          <button class="btn btn-danger px-5" ><div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
            </div></button>

        </div>
       </form>
      </div>
    </div>
  </div>




